<template>
  <div>
    <div class="uk-padding-small">
      <span class="uk-label uk-background-secondary" @click="togglePlayerCount">
        {{ $t("setup.togglePlayerCount", { count: otherPlayerCount})}}
      </span>
    </div>
    <div class="players-setup uk-section uk-padding-remove-top">
      <label class="uk-text-large">{{ twoRandomEmojis[0].symbol }} </label><input class="uk-input uk-form-width-medium uk-form-large" name="player1" placeholder="Name" v-model="namePlayer1" @input="setPlayers">
      <span v-if="playerCount === 2">vs</span>
        <input v-if="playerCount === 2" name="player2" placeholder="Name" v-model="namePlayer2" class="uk-input uk-form-width-medium uk-form-large" @input="setPlayers"><label  v-if="playerCount === 2" class="uk-text-large"> {{ twoRandomEmojis[1].symbol }}</label>
      </div>
    </div>
</template>

<script>
  import { mapGetters } from "vuex"

  export default {
    data() {
      return {
        numberOfPlayers: 2,
        emojis: [
          { symbol: "🦢", name: "Swan", name_cs: { token: "labuť", gender: "feminine"}},,
          { symbol: "🦆", name: "Duck", name_cs: { token: "kachna", gender: "feminine"}},,
          { symbol: "🐓", name: "Rooster", name_cs: { token: "kohout", gender: "masculine"}},,
          { symbol: "🐣", name: "Chick", name_cs: { token: "kuřátko", gender: "neutral"}},,
          { symbol: "🕊️", name: "Dove", name_cs: { token: "holubice", gender: "feminine"}},,
          { symbol: "🐧", name: "Penguin", name_cs: { token: "tučňák", gender: "masculine"}},,
          { symbol: "🦃", name: "Turkey", name_cs: { token: "krocan", gender: "masculine"}},,
          { symbol: "🦚", name: "Peacock", name_cs: { token: "páv", gender: "masculine"}},,
          { symbol: "🦉", name: "Owl", name_cs: { token: "sova", gender: "feminine"}},,
          { symbol: "🐔", name: "Chicken", name_cs: { token: "kuře", gender: "neutral"}},,
          { symbol: "🦅", name: "Eagle", name_cs: { token: "orel", gender: "masculine"}},
        ],
        adjectives: [
          { en: "Mighty", cs_feminine: "Mocná", cs_masculine: "Mocný", cs_neutral: "Mocné" },
          { en: "Beautiful", cs_feminine: "Nádherná", cs_masculine: "Nádherný", cs_neutral: "Nádherné" },
          { en: "Sacred", cs_feminine: "Posvátná", cs_masculine: "Posvátný", cs_neutral: "Posvátné" },
          { en: "Magnificent", cs_feminine: "Velkolepá", cs_masculine: "Velkolepý", cs_neutral: "Velkolepé" },
          { en: "Endemic", cs_feminine: "Endemická", cs_masculine: "Endemický", cs_neutral: "Endemické" },
          { en: "Curious", cs_feminine: "Zvědavá", cs_masculine: "Zvědavý", cs_neutral: "Zvědavé" },
          { en: "Hatching", cs_feminine: "Líhnoucí se", cs_masculine: "Líhnoucí se", cs_neutral: "Líhnoucí se" },
          { en: "Rare", cs_feminine: "Vzácná", cs_masculine: "Vzácný", cs_neutral: "Vzácné" }
        ],
        namePlayer1: null,
        namePlayer2: null
      }
    },
    computed: {
      ...mapGetters(["players", "language", "playerCount"]),
      twoRandomEmojis() {
        let shuffled = this.emojis.sort(() => 0.5 - Math.random());
        return shuffled.slice(0,2);
      },
      twoRandomPlayerNames() {
        let emojis = this.twoRandomEmojis;
        let adjectives = this.adjectives.sort(() => 0.5 - Math.random()).slice(0,2);

        if (this.language == "en") {
          return adjectives.map((adjective, index) => `${adjective.en} ${emojis[index].name}`)
        } else {
          return adjectives.map(function(adjective, index) {
            let birdGender = emojis[index].name_cs.gender;
            let birdName = emojis[index].name_cs.token;
            let conjugatedAdjective;

            switch(birdGender) {
              case "feminine":
                conjugatedAdjective = adjective.cs_feminine;
                break;
              case "neutral":
                conjugatedAdjective = adjective.cs_neutral;
                break;
              case "masculine":
                conjugatedAdjective = adjective.cs_masculine;
                break;
            }
            return `${conjugatedAdjective} ${emojis[index].name_cs.token}`;
          })
        }
      },
      otherPlayerCount() {
        return this.numberOfPlayers === 1 ? 2 : 1
      }
    },
    methods: {
      setPlayers: function() {
        if (!this.namePlayer1) { this.namePlayer1 = this.twoRandomPlayerNames[0] }
        if (!this.namePlayer2) { this.namePlayer2 = this.twoRandomPlayerNames[1] }
        let players = [
          { name: this.namePlayer1, emoji: this.twoRandomEmojis[0], tries: 0 }        ]
        if (this.numberOfPlayers === 2) {
          players.push({ name: this.namePlayer2, emoji: this.twoRandomEmojis[1], tries: 0 })
        }
        this.$store.dispatch("setPlayers", players)
      },
      togglePlayerCount: function() {
        if (this.numberOfPlayers == 1) {
          this.$store.dispatch("toggleSinglePlayer", { singlePlayer: false })
          this.numberOfPlayers = 2
        } else {
          this.$store.dispatch("toggleSinglePlayer", { singlePlayer: true })
          this.numberOfPlayers = 1
        }
        this.setPlayers()
      }
    },
    created() {
      this.setPlayers();
    }
  }
</script>

<style scoped>
  .players-setup {
    font-size: larger;
  }
</style>



// WEBPACK FOOTER //
// src/components/PlayerLabels.vue